import { omit, debounce } from 'lodash-es';
import { DEFAULT_DEBOUNCE_VALUE } from '../../constants.js';
class ActivityTracker {
    constructor() {
        this.trackers = [];
        this.trackDebounced = debounce(this.track.bind(this), DEFAULT_DEBOUNCE_VALUE);
    }
    getTracker(name) {
        return this.trackers.find(tracker => tracker.name === name);
    }
    getTrackers() {
        return this.trackers;
    }
    subscribe(tracker) {
        this.trackers.push(tracker);
    }
    unsubscribe(tracker) {
        this.trackers.filter(item => item !== tracker);
    }
    track(params) {
        this.trackers.forEach(tracker => tracker.trackActivity(params));
    }
    trackClick(href, title, value, params) {
        this.trackDebounced({
            href,
            type: 'click',
            title,
            value,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
    trackTextInput(href, title, params) {
        this.trackDebounced({
            href,
            type: 'textinput',
            title,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
    trackPageView(href, title, params) {
        this.trackDebounced({
            href,
            type: 'pageView',
            title,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
    trackDownload(href, title, params) {
        this.trackDebounced({
            href,
            type: 'download',
            title,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
    trackOutbound(href, title, params) {
        this.trackDebounced({
            href,
            type: 'outbound',
            title,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
    trackEvent(href, title, params) {
        this.trackDebounced({
            href,
            type: 'custom',
            title,
            ...omit(params, 'additionalParams'),
            ...params?.additionalParams
        });
    }
}
const activityTracker = new ActivityTracker();
export default activityTracker;
//# sourceMappingURL=activityTracker.js.map